import { NotificationTextMessage } from '@/core/enums/notification';
import { notifyError } from '@/core/notify/notify';

/** Angular `FormValidationService.validateForm`: true when valid, otherwise the generic mandatory-fields toast. */
export function validateForm(isValid: boolean): boolean {
  if (isValid) {
    return true;
  }
  notifyError(NotificationTextMessage.validationMessage);
  return false;
}
